import React, { createContext, useState } from 'react';

export const MyContext = createContext();

export const MyProvider = ({ children }) => {
  const [question, setQuestion] = useState(0);
  const [id_perguntaAv, setIdPerguntaAv] = useState(0);
  const [notaAv , setNota] = useState('');
  const [valorAv , setValorAv] = useState('');
  const [obsAv , setObsAv] = useState('');

  return (
    <MyContext.Provider value={{question, setQuestion,
    id_perguntaAv, setIdPerguntaAv,
    notaAv, setNota,
    valorAv , setValorAv,
    obsAv , setObsAv}}>
      {children}
    </MyContext.Provider>
  );
};


